var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lib-input-and-extra-container" }, [
    _c("input", {
      attrs: {
        type: _vm.showPassword ? "text" : "password",
        name: _vm.name,
        placeholder: _vm.placeholder,
        id: _vm.name,
        required: "",
        autocomplete: "new-password",
        "data-msg-required": "Please enter a password.",
        "data-msg-equal-to": "Passwords do not match.",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "lib-input-extra" }, [
      _c(
        "button",
        {
          staticClass: "visibility-button",
          attrs: { type: "button", tabindex: "-1" },
          on: {
            click: function ($event) {
              _vm.showPassword = !_vm.showPassword
            },
          },
        },
        [
          _c("i", {
            staticClass: "fa-regular",
            class: {
              "fa-eye": !_vm.showPassword,
              "fa-eye-slash": _vm.showPassword,
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }